import React from 'react';

export const MondayIconBorderless = (): React.JSX.Element => (
	<svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.99034 9.99041C1.63664 9.99118 1.28909 9.89805 0.983166 9.72053C0.677247 9.54302 0.423934 9.28747 0.249105 8.98001C0.0769521 8.67471 -0.0089051 8.32833 0.00073037 7.97798C0.0103658 7.62762 0.115131 7.28648 0.303804 6.99111L3.88959 1.36021C4.07311 1.05759 4.33368 0.809094 4.64467 0.64012C4.95566 0.471145 5.30592 0.387744 5.65969 0.398435C6.01319 0.406906 6.35809 0.509145 6.6591 0.694688C6.9601 0.880232 7.20641 1.14242 7.37281 1.45442C7.70708 2.08649 7.6653 2.84695 7.26494 3.44027L3.68143 9.07117C3.49971 9.35435 3.24944 9.58706 2.95382 9.74775C2.6582 9.90844 2.3268 9.99191 1.99034 9.99041Z"
			fill="#F62B54"
		/>
		<path
			d="M8.14089 9.99022C7.41766 9.99022 6.75216 9.60353 6.4027 8.9821C6.23093 8.67764 6.14527 8.33216 6.15491 7.98272C6.16454 7.63328 6.26911 7.29306 6.4574 6.99852L10.0363 1.38054C10.2172 1.07366 10.4768 0.820738 10.7883 0.648015C11.0998 0.475293 11.4519 0.389055 11.808 0.398248C12.5373 0.414202 13.1982 0.822161 13.5325 1.46031C13.8645 2.09846 13.8159 2.86347 13.4033 3.45528L9.82515 9.07326C9.64398 9.35523 9.39473 9.58704 9.10037 9.74729C8.80602 9.90755 8.47604 9.99109 8.14089 9.99022Z"
			fill="#FFCC00"
		/>
		<path
			d="M14.154 10.0374C15.1736 10.0374 16.0001 9.22818 16.0001 8.23003C16.0001 7.23187 15.1736 6.4227 14.154 6.4227C13.1344 6.4227 12.3079 7.23187 12.3079 8.23003C12.3079 9.22818 13.1344 10.0374 14.154 10.0374Z"
			fill="#00CA72"
		/>
	</svg>
);
